<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-2 gap-2">
              <h6 class="mb-0">Remisiones</h6>
              <div class="d-flex flex-wrap gap-2">
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2dce89; border-color: #2dce89; color: #fff;"
                  :disabled="printingBarcodes"
                  @click="printSelectedBarcodes"
                >
                  <i class="fas" :class="printingBarcodes ? 'fa-spinner fa-spin' : 'fa-barcode'"></i>
                  Códigos de barras
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2e389b; border-color: #2e389b; color: #fff;"
                  :disabled="selectedIds.length === 0 || sendingToProduction"
                  :title="selectedIds.length === 0 ? 'Seleccione las ventas a enviar con los checks' : `Enviar ${selectedIds.length} venta(s) a producción`"
                  @click="sendToProduction"
                >
                  <i class="fas" :class="sendingToProduction ? 'fa-spinner fa-spin' : 'fa-industry'"></i>
                  Enviar a producción
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #C2185B; border-color: #C2185B; color: #fff;"
                  :disabled="downloadingOrders"
                  @click="downloadPendingOrders"
                >
                  <i class="fas" :class="downloadingOrders ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF pedido
                </button>
                <!-- Botón oculto: PDF prod.
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #6f7a93; border-color: #6f7a93; color: #fff;"
                  :disabled="downloadingPending"
                  @click="downloadPendingItems"
                >
                  <i class="fas" :class="downloadingPending ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF prod.
                </button>
                -->
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2e389b; border-color: #2e389b; color: #fff;"
                  :disabled="downloadingPendingGrouped"
                  @click="downloadPendingItemsGrouped"
                >
                  <i class="fas" :class="downloadingPendingGrouped ? 'fa-spinner fa-spin' : 'fa-file-pdf'"></i>
                  PDF prod. agrupado
                </button>
                <button
                  v-if="!isOperator"
                  type="button"
                  class="btn btn-sm"
                  style="background-color: #2e389b; border-color: #2e389b; color: #fff;"
                  :disabled="downloadingDispatch"
                  @click="downloadDispatchRelation"
                >
                  <i class="fas" :class="downloadingDispatch ? 'fa-spinner fa-spin' : 'fa-truck'"></i>
                  Relación despacho
                </button>
                
              </div>
            </div>
            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-2 mb-3">
                <label for="searchQuery" class="mb-1">Buscar / Escanear código de barras</label>
                <input
                  ref="searchInput"
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar remisión o escanear..."
                  @input="onSearchInput"
                  @keydown.enter="onSearchEnter"
                />
              </div>
              <!-- Filtro por fecha inicio -->
              <div class="col-md-2 mb-3">
                <label for="dateFromFilter" class="mb-1">Fecha inicio</label>
                <input
                  type="date"
                  v-model="dateFromFilter"
                  id="dateFromFilter"
                  class="form-control"
                  @change="applyFilters"
                />
              </div>
              <!-- Filtro por fecha fin -->
              <div class="col-md-2 mb-3">
                <label for="dateToFilter" class="mb-1">Fecha fin</label>
                <input
                  type="date"
                  v-model="dateToFilter"
                  id="dateToFilter"
                  class="form-control"
                  @change="applyFilters"
                />
              </div>
              <!-- Filtro por pago -->
              <div class="col-md-2 mb-3">
                <label for="paidFilter" class="mb-1">Pago</label>
                <select
                  v-model="paidFilter"
                  id="paidFilter"
                  class="form-control"
                  @change="applyFilters"
                >
                  <option value="all">Todos</option>
                  <option value="paid">Pagado</option>
                  <option value="not_paid">No pagado</option>
                </select>
              </div>
              <!-- Filtro por estado preparado -->
              <div class="col-md-2 mb-3">
                <label for="statusFilter" class="mb-1">Estado</label>
                <select
                  v-model="statusFilter"
                  id="statusFilter"
                  class="form-control"
                  @change="applyFilters"
                >
                  <option value="all">Todos</option>
                  <option value="0">Pendiente</option>
                  <option value="3">En proceso</option>
                  <option value="4">Fabricado</option>
                  <option value="1">Preparado</option>
                  <option value="2">Terminado</option>
                  <option value="5">Despachado</option>
                </select>
              </div>
              <!-- Filtro por tipo -->
              <div class="col-md-2 mb-3">
                <label for="typeFilter" class="mb-1">Tipo</label>
                <select
                  v-model="typeFilter"
                  id="typeFilter"
                  class="form-control"
                  @change="applyFilters"
                >
                  <option value="all">Todos</option>
                  <option value="sale">Venta</option>
                  <option value="production">Producción</option>
                  <option value="V">Venta Normal</option>
                  <option value="Per">Personalizado</option>
                  <option value="P">Promo</option>
                </select>
              </div>
              <!-- Filtro por código de barras generado -->
              <div class="col-md-2 mb-3">
                <label for="barcodeFilter" class="mb-1">Código de barras</label>
                <select
                  v-model="barcodeFilter"
                  id="barcodeFilter"
                  class="form-control"
                  @change="applyFilters"
                >
                  <option value="all">Todos</option>
                  <option value="not_generated">Sin generar</option>
                  <option value="generated">Generado</option>
                </select>
              </div>
              <!-- Filtro por pares pendientes -->
              <div class="col-md-2 mb-3">
                <label for="pendingPairsFilter" class="mb-1">Pares pendientes</label>
                <select
                  v-model="pendingPairsFilter"
                  id="pendingPairsFilter"
                  class="form-control"
                  @change="applyFilters"
                >
                  <option value="all">Todos</option>
                  <option value="1-3">1 a 3 pares</option>
                </select>
              </div>
              <!-- Limpiar filtros -->
              <div class="col-md-2 mb-3 d-flex align-items-end">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm w-100 mb-1"
                  title="Limpiar todos los filtros"
                  @click="clearFilters"
                >
                  <i class="fas fa-broom me-1"></i> Limpiar
                </button>
              </div>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7" style="width: 40px">
                      <input type="checkbox" style="width: 16px; height: 16px; cursor: pointer; accent-color: #C2185B;" :checked="allSelected" @change="toggleSelectAll" />
                    </th>
                    <th v-if="shopifyActive" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="width: 56px">
                      &nbsp;
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      N°</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cliente</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Vendedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Tipo</th>
                    <th v-if="!isOperator" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Preparado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Pares pend.</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Cód. barras</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Total</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Pagado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Saldo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Fecha</th>
                    <th v-if="isAdmin" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      En producción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="text-center align-middle">
                      <input type="checkbox" style="width: 16px; height: 16px; cursor: pointer; accent-color: #C2185B;" :value="value.id" v-model="selectedIds" />
                    </td>
                    <td v-if="shopifyActive" class="text-center ps-4 align-middle">
                      <div class="d-flex align-items-center justify-content-center gap-2">
                        <span
                          v-if="value.shopify_id"
                          class="btn btn-link btn-sm p-0 text-success"
                          title="Sincronizado con Shopify"
                          style="cursor:default"
                        >
                          <i class="fas fa-check-circle"></i>
                        </span>
                        <button
                          v-else
                          type="button"
                          class="btn btn-link btn-sm p-0 text-secondary mb-0"
                          :disabled="syncingId === value.id"
                          title="Enviar a Shopify"
                          @click="syncToShopify(value.id)"
                        >
                          <i
                            class="fas"
                            :class="syncingId === value.id ? 'fa-spinner fa-spin' : 'fa-sync'"
                          ></i>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1 d-flex align-items-center">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <i
                          v-if="isLowPending(value)"
                          class="fas fa-exclamation-triangle text-danger pulse-alert me-1"
                          :title="`Faltan ${value.pending_pairs || 0} pares por completar`"
                          style="font-size: 14px; align-self: center;"
                        ></i>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                          <span class="text-secondary text-xs">{{ value.email }}</span>
                          <span class="text-secondary text-xs">{{ value.phone }}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.seller?.name || '—' }}</h6>
                          <span class="text-secondary text-xs">{{ value.seller?.email }}</span>
                          <span class="text-secondary text-xs">{{ value.seller?.phone }}</span>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <span class="badge badge-sm" :class="value.is_production_order ? 'bg-warning' : 'bg-success'">
                          {{ value.is_production_order ? 'Producción' : 'Venta' }}
                        </span>
                        <span v-if="value.pos_sale_type" class="badge badge-sm" :class="posSaleTypeClass(value.pos_sale_type)">
                          {{ posSaleTypeLabel(value.pos_sale_type) }}
                        </span>
                      </div>
                    </td>
                    <td v-if="!isOperator" class="align-middle text-center">
                      <select
                        :value="preparadoValue(value.preparado)"
                        class="status-select"
                        :class="preparadoPillClass(value.preparado)"
                        :disabled="isOperator"
                        @change="onPreparadoChange($event, value)"
                      >
                        <option value="0">Pendiente</option>
                        <option value="3">En proceso</option>
                        <option value="4">Fabricado</option>
                        <option value="1">Preparado</option>
                        <option value="2">Terminado</option>
                        <option value="5">Despachado</option>
                      </select>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-secondary" title="Pares pendientes por fabricar">
                        {{ parseInt(value.pending_pairs) || 0 }} pares
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        v-if="value.barcode_generated_at"
                        class="badge badge-sm bg-success"
                        :title="`Generado el ${formatDateTime(value.barcode_generated_at)}`"
                      >
                        <i class="fas fa-barcode"></i> Generado
                      </span>
                      <span v-else class="badge badge-sm bg-secondary" title="Sin generar código de barras">
                        <i class="fas fa-barcode"></i> Sin generar
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ parseFloat(value.grand_total ?? value.total ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-success text-xs font-weight-bold">
                        {{ parseFloat(totalPaid(value) ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span v-if="value.is_production_order" class="text-xs font-weight-bold text-secondary">—</span>
                      <span v-else class="text-xs font-weight-bold" :class="balance(value) > 0 ? 'text-danger' : 'text-success'">
                        {{ parseFloat(balance(value) ?? 0).toLocaleString('es-ES', {
                          minimumFractionDigits: 2, maximumFractionDigits: 2
                        }) }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}
                      </span>
                    </td>
                    <td v-if="isAdmin" class="align-middle text-center">
                      <input
                        type="checkbox"
                        style="width: 18px; height: 18px; cursor: pointer; accent-color: #2e389b;"
                        :checked="!!value.sent_to_production"
                        :disabled="sendingProductionId === value.id"
                        :title="value.sent_to_production ? 'Enviado a producción' : 'Marcar como enviado a producción'"
                        @change="onSentToProductionChange($event, value)"
                      />
                    </td>
                    <td class="align-middle text-center">
                      <!-- Si está formalizada, solo mostrar imprimir, picking/packing y ver -->
                      <template v-if="value.status == 1">
                        <div class="pos-actions-row">
                        <a
                          @click="printRemission(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Imprimir remisión"
                        >
                          <i class="fas fa-print"></i>
                        </a>

                        <a
                          @click="pickingPacking(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Picking / Packing"
                        >
                          <i class="fas fa-box"></i>
                        </a>
                        
                        <router-link
                          v-if="!isOperator"
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Ver remisión">
                          <i class="fa fa-eye"></i>
                        </router-link>

                        <a v-if="isAdmin && value.type === 'return'" @click="deleteUser(value.id)" class="text-danger font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                        </div>
                      </template>

                      <!-- Si está pendiente, mostrar todas las opciones -->
                      <template v-else>
                        <div class="pos-actions-row">
                        <a
                          @click="printRemission(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Imprimir remisión"
                        >
                          <i class="fas fa-print"></i>
                        </a>

                        <a
                          @click="pickingPacking(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip"
                          data-original-title="Picking / Packing"
                        >
                          <i class="fas fa-box"></i>
                        </a>
                        
                        <router-link
                          v-if="!isOperator"
                          :to="{ name: 'Remissions Create', params: { data: JSON.stringify(value) }, props: true }"
                          class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                          data-original-title="Editar Registro">
                          <i class="fa fa-pencil-alt"></i>
                        </router-link>

                        <a v-if="isAdmin && value.type === 'return'" @click="deleteUser(value.id)" class="text-danger font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                        </div>
                      </template>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td :colspan="tableColspan" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Picking / Packing -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import JsBarcode from 'jsbarcode';
import remissionsService from '@/services/remissions.service';
import productionOrdersService from '@/services/productionOrders.service';
import mediaService from '@/services/media.service';
import { compressImage } from '@/utils/compressImage';



export default {
  name: 'ProjectsList',
  data() {
    return {
      searchQuery: '',
      statusFilter: 'all',
      paidFilter: 'all',
      barcodeFilter: 'all',
      pendingPairsFilter: 'all',
      typeFilter: 'all',
      dateFromFilter: '',
      dateToFilter: '',
      page: 1,
      syncingId: null,
      shopifyActive: false,
      downloadingPending: false,
      downloadingPendingGrouped: false,
      downloadingOrders: false,
      downloadingDispatch: false,
      printingBarcodes: false,
      selectedIds: [],
      user: {},
      scanStartTime: 0,
      scanBuffer: '',
      scanTimer: null,
      sendingProductionId: null,
      sendingToProduction: false,
    };
  },
  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
    allSelected() {
      return this.data.length > 0 && this.data.every((d) => this.selectedIds.includes(d.id));
    },
    isOperator() {
      return this.user?.role === '3' || this.user?.role === 3;
    },
    isAdmin() {
      return this.user?.role === '1' || this.user?.role === 1;
    },
    // Total de columnas visibles para el colspan de la fila "sin registros".
    tableColspan() {
      let count = 12; // base: checkbox, N°, Cliente, Vendedor, Tipo, Preparado, Cód.barras, Total, Pagado, Saldo, Fecha, Opciones
      if (this.shopifyActive) count += 1;
      if (this.isAdmin) count += 1;
      if (this.isOperator) count -= 1; // operarios no ven la columna Preparado
      return count;
    },
  },
  methods: {
    posSaleTypeLabel(type) {
      const labels = { V: 'Venta Normal', P: 'Promo', Per: 'Personalizado' };
      return labels[type] || type;
    },
    posSaleTypeClass(type) {
      const classes = { V: 'bg-success', P: 'bg-info', Per: 'bg-danger' };
      return classes[type] || 'bg-secondary';
    },
    totalPaid(value) {
      if (!value.payments || !Array.isArray(value.payments)) return 0;
      return value.payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
    },
    balance(value) {
      return parseFloat(value.grand_total ?? value.total ?? 0) - this.totalPaid(value);
    },
    toggleSelectAll(event) {
      if (event.target.checked) {
        this.selectedIds = this.data.map((d) => d.id);
      } else {
        this.selectedIds = [];
      }
    },
    async printSelectedBarcodes() {
      if (this.selectedIds.length === 0) {
        await Swal.fire('Atención', 'Seleccione al menos una remisión', 'warning');
        return;
      }
      this.printingBarcodes = true;
      try {
        // Construir las etiquetas a partir de las remisiones seleccionadas (datos ya en memoria)
        const selected = this.data.filter((d) => this.selectedIds.includes(d.id));

        const labels = selected.map((r) => {
          const name = (r.name || (r.user && r.user.name) || 'CLIENTE').toUpperCase();
          const date = new Date(r.created_at).toLocaleDateString('es-ES');
          const id = 'LY' + String(r.id);
          const posSaleType = r.pos_sale_type || '';
          const totalQty = (r.details || []).reduce((sum, d) => sum + (parseInt(d.quantity) || 0), 0);

          const tmpSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          JsBarcode(tmpSvg, id, {
            format: 'CODE128',
            displayValue: false,
            fontSize: 12,
            height: 50,
            margin: 0,
            width: 2,
          });
          const barcodeSvg = new XMLSerializer().serializeToString(tmpSvg);

          return `
            <div class="label">
              <div class="label-name">${name}</div>
              <div class="label-date">${date}</div>
              <div class="label-body">${barcodeSvg}</div>
              <div class="label-footer">
                <span class="label-number">${id}</span>
                <span class="label-saletype">${posSaleType}-${totalQty}</span>
              </div>
            </div>`;
        });

        let rows = '';
        const remainder = labels.length % 3;
        if (remainder > 0) {
          for (let i = 0; i < (3 - remainder); i++) {
            labels.push('<div class="label label-empty"></div>');
          }
        }
        for (let i = 0; i < labels.length; i++) {
          if (i % 3 === 0) rows += '<div class="label-row">';
          rows += labels[i];
          if (i % 3 === 2 || i === labels.length - 1) rows += '</div>';
        }

        const html = `
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="utf-8" />
            <title>Imprimir códigos de barras</title>
            <style>
              @page { size: 104mm 25mm; margin: 0; }
              * { box-sizing: border-box; }
              html, body { margin: 0; padding: 0; }
              .label-row {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 104mm;
                height: 25mm;
                page-break-after: always;
              }
              .label {
                width: 34mm;
                height: 25mm;
                padding: 3mm;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-family: Arial, Helvetica, sans-serif;
                overflow: hidden;
              }
              .label-empty {
                visibility: hidden;
              }
              .label-name {
                font-size: 7pt;
                font-weight: bold;
                word-break: break-word;
                line-height: 1.1;
                text-align: center;
                width: 100%;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .label-date {
                font-size: 7pt;
                text-align: center;
                width: 100%;
                color: #333;
              }
              .label-body {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .label-body svg {
                width: 100%;
                height: auto;
                max-height: 8mm;
                display: block;
              }
              .label-footer {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
              }
              .label-number {
                font-size: 7pt;
                font-weight: bold;
                text-align: left;
                letter-spacing: 0.5pt;
              }
              .label-saletype {
                font-size: 7pt;
                font-weight: bold;
                text-align: right;
                color: #333;
              }
            </style>
          </head>
          <body onload="window.onafterprint = function(){ window.close(); }; setTimeout(function(){ window.print(); }, 100);">
            ${rows}
          </body>
          </html>`;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        if (!printWindow) {
          await Swal.fire('Bloqueado', 'Permita las ventanas emergentes para imprimir.', 'warning');
          return;
        }
        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        // Marcar las remisiones como "código de barras generado"
        await remissionsService.markBarcodeGenerated(selected.map((r) => r.id));
        await this.fetchData();
      } catch (error) {
        console.error('Error al generar códigos de barras:', error);
        await Swal.fire('Error', 'No se pudieron generar los códigos de barras.', 'error');
      } finally {
        this.printingBarcodes = false;
      }
    },
    async downloadPendingOrders() {
      if (this.selectedIds.length === 0) {
        await Swal.fire('Atención', 'Seleccione al menos una remisión', 'warning');
        return;
      }
      this.downloadingOrders = true;
      try {
        const response = await remissionsService.getPendingOrders(this.selectedIds);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `pedidos_pendientes_${new Date().toISOString().slice(0,10)}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar PDF de pedidos pendientes:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF de pedidos', 'error');
      } finally {
        this.downloadingOrders = false;
      }
    },
    async downloadPendingItems() {
      if (this.selectedIds.length === 0) {
        await Swal.fire('Atención', 'Seleccione al menos una remisión', 'warning');
        return;
      }
      this.downloadingPending = true;
      try {
        const response = await remissionsService.getPendingItems(this.selectedIds);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `pendientes_creacion_${new Date().toISOString().slice(0,10)}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar PDF de pendientes:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF de pendientes', 'error');
      } finally {
        this.downloadingPending = false;
      }
    },
    async downloadPendingItemsGrouped() {
      if (this.selectedIds.length === 0) {
        await Swal.fire('Atención', 'Seleccione al menos una remisión', 'warning');
        return;
      }
      this.downloadingPendingGrouped = true;
      try {
        const response = await remissionsService.getPendingItemsGrouped(this.selectedIds);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `pendientes_agrupados_${new Date().toISOString().slice(0,10)}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar PDF de pendientes agrupados:', error);
        await Swal.fire('Error', 'No se pudo generar el PDF de pendientes agrupados', 'error');
      } finally {
        this.downloadingPendingGrouped = false;
      }
    },
    async downloadDispatchRelation() {
      const selectedTerminados = this.data.filter(
        (d) => this.selectedIds.includes(d.id) && this.preparadoValue(d.preparado) === '2'
      );
      if (this.selectedIds.length > 0 && selectedTerminados.length === 0) {
        await Swal.fire('Atención', 'Ninguna de las remisiones seleccionadas está en estado Terminado', 'warning');
        return;
      }
      const scopeText = this.selectedIds.length > 0
        ? `Se incluirán ${selectedTerminados.length} remisión(es) seleccionada(s) en estado Terminado.`
        : 'Se incluirán todas las remisiones en estado Terminado.';
      const confirm = await Swal.fire({
        title: 'Generar relación de despacho',
        html: `<p>${scopeText}</p><p>Al generar el PDF pasarán a estado <b>Despachado</b>.</p>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#2e389b',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, generar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.downloadingDispatch = true;
      try {
        const ids = selectedTerminados.map((d) => d.id);
        const response = await remissionsService.getDispatchRelation(ids);
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `relacion_despacho_${new Date().toISOString().slice(0,10)}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.selectedIds = [];
        await this.fetchData();
      } catch (error) {
        console.error('Error al generar la relación de despacho:', error);
        let message = 'No se pudo generar la relación de despacho';
        const data = error.response?.data;
        if (data instanceof Blob) {
          try {
            const parsed = JSON.parse(await data.text());
            if (parsed.message) message = parsed.message;
          } catch (e) { /* respuesta no JSON */ }
        } else if (data?.message) {
          message = data.message;
        }
        await Swal.fire('Error', message, 'error');
      } finally {
        this.downloadingDispatch = false;
      }
    },
    // Los cambios de filtro / búsqueda vuelven a la primera página
    applyFilters() {
      this.page = 1;
      this.fetchData();
    },
    clearFilters() {
      this.searchQuery = '';
      this.statusFilter = 'all';
      this.paidFilter = 'all';
      this.barcodeFilter = 'all';
      this.pendingPairsFilter = 'all';
      this.typeFilter = 'all';
      this.dateFromFilter = '';
      this.dateToFilter = '';
      this.page = 1;
      this.fetchData();
    },
    async fetchData(pageUrl = null) {
      if (pageUrl) {
        const parsed = parseInt(new window.URL(pageUrl).searchParams.get('page'));
        this.page = Number.isNaN(parsed) ? 1 : parsed;
      }
      const params = {
        search: this.searchQuery,
        preparado: this.statusFilter,
        paid: this.paidFilter,
        barcode: this.barcodeFilter,
        pending_pairs: this.pendingPairsFilter !== 'all' ? this.pendingPairsFilter : undefined,
        type: this.typeFilter,
        date_from: this.dateFromFilter || undefined,
        date_to: this.dateToFilter || undefined,
        page: this.page,
        per_page: 100,
      };
      if (this.isOperator && this.user.id) {
        params.seller_id = this.user.id;
      }
      await this.$store.dispatch('remissions/fetchData', params);

      // Si la página quedó fuera de rango (p. ej. tras eliminar registros), ir a la última válida
      if (this.data.length === 0 && this.page > 1 && this.lastPage >= 1) {
        this.page = this.lastPage;
        await this.$store.dispatch('remissions/fetchData', { ...params, page: this.page });
      }
      this.syncQuery();
    },
    // Refleja página y filtros en la URL para conservarlos al recargar el navegador
    syncQuery() {
      const query = {};
      if (this.page > 1) query.page = String(this.page);
      if (this.searchQuery) query.search = this.searchQuery;
      if (this.statusFilter !== 'all') query.preparado = this.statusFilter;
      if (this.paidFilter !== 'all') query.paid = this.paidFilter;
      if (this.barcodeFilter !== 'all') query.barcode = this.barcodeFilter;
      if (this.pendingPairsFilter !== 'all') query.pending_pairs = this.pendingPairsFilter;
      if (this.typeFilter !== 'all') query.type = this.typeFilter;
      if (this.dateFromFilter) query.date_from = this.dateFromFilter;
      if (this.dateToFilter) query.date_to = this.dateToFilter;
      localStorage.setItem('remissionsTableState', JSON.stringify(query));
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(() => {});
      }
    },
    restoreQuery() {
      // Si se entra sin query (p. ej. desde el menú), se recupera el último estado guardado
      let q = this.$route.query;
      if (Object.keys(q).length === 0) {
        try {
          q = JSON.parse(localStorage.getItem('remissionsTableState') || '{}');
        } catch (e) {
          q = {};
        }
      }
      this.page = parseInt(q.page) > 0 ? parseInt(q.page) : 1;
      this.searchQuery = q.search || '';
      this.statusFilter = q.preparado || 'all';
      this.paidFilter = q.paid || 'all';
      this.barcodeFilter = q.barcode || 'all';
      this.pendingPairsFilter = q.pending_pairs || 'all';
      this.typeFilter = q.type || 'all';
      this.dateFromFilter = q.date_from || '';
      this.dateToFilter = q.date_to || '';
    },
    onSearchInput() {
      // Detectar escaneo rápido de código de barras
      const now = Date.now();
      if (now - this.scanStartTime > 100) {
        // Reiniciar buffer si pasó mucho tiempo (escritura humana)
        this.scanStartTime = now;
        this.scanBuffer = '';
      }
      this.scanBuffer = this.searchQuery;
      // Debounce normal para búsqueda
      clearTimeout(this.scanTimer);
      this.scanTimer = setTimeout(() => {
        this.applyFilters();
      }, 300);
    },
    async onSearchEnter() {
      const code = this.searchQuery.trim();
      if (!code) return;
      // Si el input fue muy rápido (< 100ms), es un escaneo de código de barras
      const elapsed = Date.now() - this.scanStartTime;
      if (elapsed < 100 && code.length >= 4) {
        // Es un escaneo de pistola
        await this.handleBarcodeScan(code);
      } else {
        // Enter manual, hacer búsqueda normal
        this.applyFilters();
      }
    },
    async handleBarcodeScan(code) {
      // Si el código empieza con "L" (etiqueta de remisión LY<id>),
      // quitar la "L" y usar el número restante como ID de la remisión
      // para buscarla y cambiar su estado a Terminado.
      if (code.toUpperCase().startsWith('LY')) {
        const numericPart = code.replace(/^[Ll][Yy]/, '').trim();
        const remissionId = parseInt(numericPart, 10);
        if (!remissionId || isNaN(remissionId)) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: `No se pudo interpretar el código: ${code}`,
            timer: 2000,
            showConfirmButton: false,
          });
          this.searchQuery = '';
          return;
        }
        await this.handleRemissionIdScan(remissionId);
        return;
      }
      try {
        const res = await remissionsService.findByBarcode(code);
        const data = res.data;
        if (!data.found || !data.remissions || data.remissions.length === 0) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: `No se encontró ningún pedido con el código de barras: ${code}`,
            timer: 2000,
            showConfirmButton: false,
          });
          this.searchQuery = '';
          return;
        }
        // Si hay múltiples, tomar el primero (más reciente)
        const remission = data.remissions[0];
        if (parseInt(remission.preparado) === 2) {
          // Está terminado, ofrecer cambiar a despachado
          const result = await Swal.fire({
            icon: 'question',
            title: `Pedido #${remission.id}`,
            html: `<p>Cliente: <b>${remission.name}</b></p>
                   <p>Estado actual: <b>Terminado</b></p>
                   <p>¿Desea cambiar el estado a <b>Despachado</b>?</p>`,
            showCancelButton: true,
            confirmButtonText: 'Sí, despachar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#2e389b',
          });
          if (result.isConfirmed) {
            try {
              await remissionsService.updatePreparado(remission.id, 5);
              await Swal.fire({
                icon: 'success',
                title: 'Despachado',
                text: `Pedido #${remission.id} cambiado a Despachado`,
                timer: 1500,
                showConfirmButton: false,
              });
              this.fetchData();
            } catch (err) {
              await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response?.data?.message || 'No se pudo actualizar el estado',
              });
            }
          }
        } else {
          // No está terminado
          await this.warnNotTerminado(remission);
        }
      } catch (error) {
        if (error.response?.status === 404) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: `No se encontró ningún pedido con el código de barras: ${code}`,
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al buscar el código de barras',
          });
        }
      }
      this.searchQuery = '';
    },
    async handleRemissionIdScan(remissionId) {
      try {
        const res = await remissionsService.getData(remissionId);
        const remission = res.data?.data || res.data;
        if (!remission || !remission.id) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: `No se encontró el pedido #${remissionId}`,
            timer: 2000,
            showConfirmButton: false,
          });
          this.searchQuery = '';
          return;
        }
        const currentStatus = this.preparadoLabel(remission.preparado);
        const detailsHtml = this.buildDetailsTableHtml(remission);
        const isTerminado = parseInt(remission.preparado) === 2;

        if (isTerminado) {
          const result = await Swal.fire({
            icon: 'info',
            title: `Pedido #${remission.id}`,
            html: `<p>Cliente: <b>${remission.name || ''}</b></p>
                   <p>Estado actual: <b>${currentStatus}</b></p>
                   ${detailsHtml}`,
            showCancelButton: true,
            confirmButtonText: 'Ver detalles',
            cancelButtonText: 'Cerrar',
            confirmButtonColor: '#2e389b',
          });
          if (result.isConfirmed) {
            this.pickingPacking(remission.id);
          }
          this.fetchData();
          this.searchQuery = '';
          return;
        }

        const result = await this.confirmFinishWithEvidence(remission);
        if (result.isConfirmed) {
          try {
            await remissionsService.updatePreparado(remission.id, 2);
            await Swal.fire({
              icon: 'success',
              title: 'Terminado',
              text: `Pedido #${remission.id} cambiado a Terminado`,
              timer: 1500,
              showConfirmButton: false,
            });
            this.fetchData();
          } catch (err) {
            await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: err.response?.data?.message || 'No se pudo actualizar el estado',
            });
          }
        } else if (result.isDenied) {
          this.pickingPacking(remission.id);
        }
      } catch (error) {
        if (error.response?.status === 404) {
          await Swal.fire({
            icon: 'info',
            title: 'Sin resultados',
            text: `No se encontró el pedido #${remissionId}`,
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al buscar el pedido',
          });
        }
      }
      this.searchQuery = '';
    },
    // Modal para terminar un pedido: la foto de evidencia es opcional.
    // Devuelve el resultado de Swal (isConfirmed / isDenied / isDismissed).
    async confirmFinishWithEvidence(remission, saldo = 0) {
      const currentStatus = this.preparadoLabel(remission.preparado);
      const detailsHtml = this.buildDetailsTableHtml(remission);
      const saldoHtml = saldo > 0
        ? `<p style="color:#C2185B;font-weight:600;">⚠ Saldo pendiente: $${parseFloat(saldo).toLocaleString('es-ES', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
          })}</p>`
        : '';

      return await Swal.fire({
        icon: 'question',
        title: `Pedido #${remission.id}`,
        html: `<p>Cliente: <b>${remission.name || ''}</b></p>
               <p>Estado actual: <b>${currentStatus}</b></p>
               ${detailsHtml}
               ${saldoHtml}
               <p>¿Desea cambiar el estado a <b>Terminado</b>?</p>
               <div style="margin-top:10px;">
                 <button type="button" id="evidence-upload-btn" style="background:#2dce89;border:none;color:#fff;padding:8px 14px;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;">
                   <i class="fas fa-camera"></i> Subir foto de evidencia
                 </button>
                 <div id="evidence-status" style="margin-top:6px;font-size:12px;color:#6c757d;font-weight:600;">Opcional: puedes subir una foto de evidencia</div>
               </div>`,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Sí, terminar',
        denyButtonText: 'Ver detalles',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#2e389b',
        denyButtonColor: '#6c757d',
        allowOutsideClick: false,
        didOpen: () => {
          const popup = Swal.getPopup();
          const btn = popup.querySelector('#evidence-upload-btn');
          const statusEl = popup.querySelector('#evidence-status');
          // capture="environment" abre la cámara directamente en móvil
          const input = document.createElement('input');
          input.type = 'file';
          input.id = 'evidence-camera-input';
          input.accept = 'image/*';
          input.setAttribute('capture', 'environment');
          input.style.display = 'none';
          popup.appendChild(input);
          btn.addEventListener('click', () => input.click());
          input.addEventListener('change', async () => {
            const file = input.files && input.files[0];
            input.value = '';
            if (!file) return;
            btn.disabled = true;
            btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Subiendo...';
            try {
              const compressed = await compressImage(file);
              const formData = new FormData();
              formData.append('mediaable_id', remission.id);
              formData.append('mediaable_type', 'remission');
              formData.append('file', compressed);
              await mediaService.createData(formData);
              statusEl.innerHTML = '<span style="color:#2dce89;">✓ Foto de evidencia subida</span>';
              btn.innerHTML = '<i class="fas fa-camera"></i> Cambiar foto';
            } catch (error) {
              console.error('Error al subir evidencia:', error);
              statusEl.innerHTML = '<span style="color:#f5365c;">✗ No se pudo subir la foto (máx. 10 MB). Intenta de nuevo.</span>';
              btn.innerHTML = '<i class="fas fa-camera"></i> Subir foto de evidencia';
            } finally {
              btn.disabled = false;
            }
          });
        },
      });
    },
    buildDetailsTableHtml(remission) {
      const details = remission.details || [];
      if (details.length === 0) {
        return '<p class="text-muted">Sin productos</p>';
      }
      const rows = details.map((d) => {
        const name = d.inventory?.name || d.model?.name || 'Producto';
        const size = d.variant?.size?.size || d.productionModel?.size?.size || '—';
        const color = d.variant?.color?.name || d.productionModel?.size?.color?.name || d.inventory?.color?.name || '—';
        const qty = d.quantity || 0;
        const prepared = d.prepared
          ? '<span style="color:#2dce89;font-weight:600;">✓ Preparado</span>'
          : '<span style="color:#f5365c;font-weight:600;">✗ No preparado</span>';
        return `<tr>
          <td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:left;">${name}</td>
          <td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:center;">${size}</td>
          <td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:center;">${color}</td>
          <td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:center;">${qty}</td>
          <td style="padding:4px 8px;border-bottom:1px solid #eee;text-align:center;">${prepared}</td>
        </tr>`;
      }).join('');
      return `
        <div style="margin:10px 0;max-height:240px;overflow-y:auto;">
          <table style="width:100%;border-collapse:collapse;font-size:13px;">
            <thead>
              <tr style="background:#f8f9fa;">
                <th style="padding:6px 8px;text-align:left;">Producto</th>
                <th style="padding:6px 8px;text-align:center;">Talla</th>
                <th style="padding:6px 8px;text-align:center;">Color</th>
                <th style="padding:6px 8px;text-align:center;">Cant.</th>
                <th style="padding:6px 8px;text-align:center;">Estado</th>
              </tr>
            </thead>
            <tbody>${rows}</tbody>
          </table>
        </div>`;
    },
    async warnNotTerminado(remission) {
      const result = await Swal.fire({
        icon: 'warning',
        title: `Pedido #${remission.id}`,
        html: `<p>Cliente: <b>${remission.name || ''}</b></p>
               <p>Estado actual: <b>${this.preparadoLabel(remission.preparado)}</b></p>
               <p>No se puede cambiar a <b>Despachado</b> porque el pedido no está en estado <b>Terminado</b>.</p>`,
        showCancelButton: true,
        confirmButtonText: 'Ver pedido',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#2e389b',
        cancelButtonColor: '#6c757d',
      });
      if (result.isConfirmed) {
        this.pickingPacking(remission.id);
      }
    },
    preparadoLabel(preparado) {
      const v = this.preparadoValue(preparado);
      const labels = {
        '0': 'Pendiente',
        '1': 'Preparado',
        '2': 'Terminado',
        '3': 'En proceso',
        '4': 'Fabricado',
        '5': 'Despachado',
      };
      return labels[v] || 'Pendiente';
    },
    formatDateTime(value) {
      if (!value) return '';
      return new Date(value).toLocaleString('es-ES');
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async syncToShopify(id) {
      try {
        this.syncingId = id;
        const response = await this.$store.dispatch('remissions/syncToShopify', id);
        if (response && response.status >= 200 && response.status < 300) {
          await this.fetchData();
          await Swal.fire('Éxito', 'Remisión sincronizada con Shopify', 'success');
        } else {
          throw new Error(response.data?.message || 'Error al sincronizar');
        }
      } catch (error) {
        console.error("Error al sincronizar con Shopify:", error);
        await Swal.fire(
          'Error',
          error.response?.data?.message || 'Error al sincronizar con Shopify',
          'error'
        );
      } finally {
        this.syncingId = null;
      }
    },
    preparadoValue(preparado) {
      if (preparado === true || preparado === 1) return '1';
      if (preparado === 2) return '2';
      if (preparado === 3) return '3';
      if (preparado === 4) return '4';
      if (preparado === 5) return '5';
      return '0';
    },
    isLowPending(value) {
      const pending = parseInt(value.pending_pairs) || 0;
      return pending >= 1 && pending <= 3;
    },
    preparadoPillClass(preparado) {
      const v = this.preparadoValue(preparado);
      if (v === '5') return 'status-pill--dispatched';
      if (v === '2') return 'status-pill--completed';
      if (v === '1') return 'status-pill--in-progress';
      if (v === '4') return 'status-pill--fabricated';
      if (v === '3') return 'status-pill--process';
      return 'status-pill--pending';
    },
    async onPreparadoChange(event, value) {
      const newVal = parseInt(event.target.value);
      const current = this.preparadoValue(value.preparado);
      const target = event.target;
      const row = value;
      if (newVal.toString() === current) return;
      try {
        // No se puede cambiar a Fabricado (4) desde la tabla
        if (newVal === 4) {
          target.value = current;
          await Swal.fire({
            icon: 'warning',
            title: 'Cambio no permitido',
            text: 'El estado Fabricado solo se alcanza cuando los productos en proceso pasan a fabricado dentro del pedido. No se puede cambiar a Fabricado desde la tabla.',
            confirmButtonColor: '#2e389b',
          });
          return;
        }
        // Solo se puede despachar (5) si el pedido está en Terminado (2)
        if (newVal === 5 && current !== '2') {
          target.value = current;
          await this.warnNotTerminado(row);
          return;
        }
        // Al cambiar a Terminado (2) se muestra el modal con la foto de evidencia opcional
        if (newVal === 2) {
          const saldo = row.is_production_order ? 0 : this.balance(row);
          const result = await this.confirmFinishWithEvidence(row, saldo);
          if (!result.isConfirmed) {
            target.value = current;
            return;
          }
        }
        await remissionsService.updatePreparado(row.id, newVal);
        row.preparado = newVal;
      } catch (error) {
        target.value = current;
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo actualizar el estado',
        });
      }
    },
    async onSentToProductionChange(event, value) {
      const newVal = event.target.checked;
      const target = event.target;
      this.sendingProductionId = value.id;
      try {
        await remissionsService.updateSentToProduction(value.id, newVal);
        this.applySentToProduction(value.id, newVal);
      } catch (error) {
        target.checked = !newVal;
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo actualizar el estado de envío a producción',
        });
      } finally {
        this.sendingProductionId = null;
      }
    },
    applySentToProduction(id, sentToProduction) {
      const row = this.data.find((d) => d.id === id);
      if (row) {
        row.sent_to_production = sentToProduction;
      }
    },
    async sendToProduction() {
      if (this.selectedIds.length === 0) {
        await Swal.fire('Atención', 'Seleccione al menos una venta con los checks', 'warning');
        return;
      }
      const selected = this.data.filter((d) => this.selectedIds.includes(d.id));
      const alreadySent = selected.filter((d) => d.sent_to_production);
      if (alreadySent.length > 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Ventas ya enviadas',
          text: `Las ventas ${alreadySent.map((d) => d.id).join(', ')} ya fueron enviadas a producción. Quite los checks de esas ventas.`,
          confirmButtonColor: '#2e389b',
        });
        return;
      }
      // Las personalizadas (Per) envían todos sus productos sin validar stock
      const personalizadas = selected.filter((d) => d.pos_sale_type === 'Per');
      const notaPersonalizadas = personalizadas.length > 0
        ? `<br><span class="text-xs">Las ventas personalizadas <b>#${personalizadas.map((d) => d.id).join(', #')}</b> enviarán <b>todos</b> sus productos a producción, sin validar stock.</span>`
        : '';
      const result = await Swal.fire({
        title: 'Enviar a producción',
        html: `Se enviarán <b>${selected.length}</b> venta(s) a producción.<br>` +
          `Las ventas pasarán a estado <b>En proceso</b> y sus productos pendientes sin stock entrarán a producción.` +
          notaPersonalizadas,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#2e389b',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, enviar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.sendingToProduction = true;
      try {
        const response = await productionOrdersService.send(this.selectedIds);
        const order = response.data.production_order;
        const totalItems = (response.data.remission_items || []).reduce((s, r) => s + (parseInt(r.products) || 0), 0);
        const totalPairs = (response.data.remission_items || []).reduce((s, r) => s + (parseInt(r.pairs) || 0), 0);
        await Swal.fire({
          icon: 'success',
          title: 'Producción creada',
          html: `Se creó la producción <b>#${order.id}</b> con <b>${totalPairs}</b> pares (${totalItems} producto(s)) de <b>${selected.length}</b> venta(s).<br>` +
            'Las ventas quedaron en estado <b>En proceso</b>.',
          confirmButtonColor: '#2e389b',
        });
        this.selectedIds = [];
        await this.fetchData();
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo enviar a producción',
        });
      } finally {
        this.sendingToProduction = false;
      }
    },
    pickingPacking(id) {
      this.$router.push({ name: 'Remissions PickingPacking', query: { id } });
    },
    printRemission(id) {
      const routeData = this.$router.resolve({ name: 'POS Ticket', query: { id } });
      window.open(routeData.href, '_blank');
    },
  },
  async mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      this.user = user;
    }
    this.restoreQuery();
    this.fetchData();
    try {
      const res = await this.$store.dispatch('settings/get');
      this.shopifyActive = !!res.data.shopify_active;
    } catch (e) {
      console.error('Error loading settings:', e);
    }
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.pos-actions-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.status-select {
  border: none;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 24px;
}
.status-select.status-pill--pending {
  background-color: #fff3cd;
  color: #856404;
}
.status-select.status-pill--process {
  background-color: #e2e3e5;
  color: #6c757d;
}
.status-select.status-pill--fabricated {
  background-color: #cce5ff;
  color: #004085;
}
.status-select.status-pill--in-progress {
  background-color: #d1ecf1;
  color: #0c5460;
}
.status-select.status-pill--completed {
  background-color: #d4edda;
  color: #155724;
}
.status-select.status-pill--dispatched {
  background-color: #d6d8ff;
  color: #2e389b;
}
.status-select:hover {
  opacity: 0.85;
}
.obs-box {
  width: 160px;
  max-height: 54px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  white-space: normal !important;
  font-size: 10px;
  line-height: 1.2;
  color: #555;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 3px 6px;
  margin: 0 auto;
  cursor: pointer;
  text-align: left;
  word-break: break-word;
}
.obs-box:hover {
  background-color: #eef0f2;
}
.pulse-alert {
  animation: pulse-red 1s infinite;
}
@keyframes pulse-red {
  0% {
    opacity: 1;
    transform: scale(1);
    text-shadow: 0 0 0 rgba(220, 53, 69, 0);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2);
    text-shadow: 0 0 8px rgba(220, 53, 69, 0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    text-shadow: 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>
